import React from 'react';

export class DropdownSubmenu extends React.Component {
  constructor() {
    super(...arguments);
    this.refSubMenuContent = null;
    this.onClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (this.refSubMenuContent) {
        let show = false;
        if (this.refSubMenuContent.classList.contains('show')) {
          DropdownSubmenu.hideChildren(this.refSubMenuContent);
        } else {
          show = true;
          this.hideSibblings();
        }
        this.refSubMenuContent.classList.toggle('show');
        if (typeof this.props.onToggle === 'function') {
          this.props.onToggle(show, event, { source: 'select' });
        }
      }
    };
    this.hideSibblings = () => {
      if (this.refSubMenuContent) {
        const parents = DropdownSubmenu.getParents(this.refSubMenuContent, '.dropdown-menu.show');
        if (parents.length > 1) {
          DropdownSubmenu.hideChildren(parents[1]);
        }
      }
    };
    this.onMouseLeave = (e) => {
      // TODO - if required mouse out event
    };
  }
  render() {
    let className = 'dropdown-submenu-container';
    className = this.props.className ? className + ' ' + this.props.className : className;
    return React.createElement(
      'div',
      { className: className, id: this.props.id },
      React.createElement(
        'a',
        {
          href: this.props.href,
          className: 'dropdown-item dropdown-submenu dropdown-toggle',
          onMouseEnter: this.onClick,
          onMouseLeave: this.onMouseLeave
        },
        this.props.title
      ),
      React.createElement('div', { className: 'dropdown-menu', ref: (ref) => (this.refSubMenuContent = ref) }, this.props.children)
    );
  }
  static hideChildren(parent) {
    const children = parent.querySelectorAll('.dropdown-menu.show');
    for (const child of children) {
      child.classList.remove('show');
    }
  }
  static getParents(elem, selector) {
    const nodes = [];
    let element = elem;
    nodes.push(element);
    while (element.parentNode) {
      if (typeof element.parentNode.matches === 'function' && element.parentNode.matches(selector)) {
        nodes.push(element.parentNode);
      }
      element = element.parentNode;
    }
    return nodes;
  }
}
